import React, { useContext, useMemo, useState } from 'react';

export interface PlansRefetchContextType {
  fetchKey: number;
  setFetchKey: React.Dispatch<React.SetStateAction<number>>;
}

export const PlansRefetchContext = React.createContext<PlansRefetchContextType>(
  { fetchKey: 0, setFetchKey: () => 0 },
);

const PlansRefetchProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [fetchKey, setFetchKey] = useState(0);

  const value = useMemo(() => ({ fetchKey, setFetchKey }), [fetchKey]);

  return (
    <PlansRefetchContext.Provider value={value}>
      {children}
    </PlansRefetchContext.Provider>
  );
};

export const usePlansRefetch = () => {
  const context = useContext(PlansRefetchContext);

  if (!context) {
    throw new Error(
      'usePlansRefetch should be used inside PlansRefetchProvider.',
    );
  }
  return context;
};

export default PlansRefetchProvider;
